import { ErrorCategory } from './errorTypes';

const ERROR_MESSAGES: Record<ErrorCategory, string> = {
  [ErrorCategory.DATABASE]: 'Unable to save your changes. Please try again.',
  [ErrorCategory.NETWORK]: 'Connection issue. Please check your internet connection.',
  [ErrorCategory.PERMISSION]: "You don't have access to this feature. Please contact your administrator.",
  [ErrorCategory.VALIDATION]: 'Please check your input and try again.',
  [ErrorCategory.AUTHENTICATION]: 'Please sign in to continue.',
  [ErrorCategory.NOT_FOUND]: 'The requested item could not be found.',
  [ErrorCategory.RATE_LIMIT]: 'Too many requests. Please wait a moment and try again.',
  [ErrorCategory.UNKNOWN]: 'Something went wrong. Please try again.'
};

export const getErrorMessage = (category: ErrorCategory, customMessage?: string): string => {
  return customMessage || ERROR_MESSAGES[category];
};

export const getFieldErrorMessage = (field: string, message: string): string => {
  // Extract the specific error from database validation messages
  if (message.toLowerCase().includes('validation failed')) {
    const parts = message.split(':');
    if (parts.length > 1) {
      return parts[1].trim();
    }
  }
  return message;
};
